import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipeModule } from '../../translate/translate.pipe.module';
import { CreateQuestionnaireComponent } from './create-questionnaire.component';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { NgxSelectModule } from 'ngx-select-ex';
@NgModule({
  imports:[CommonModule,TranslatePipeModule,FormsModule,ReactiveFormsModule,NgxSelectModule],
  declarations: [CreateQuestionnaireComponent],
  providers: [],
  exports: [CreateQuestionnaireComponent]
})
export class CreateQuestionnaireModule {

}
